import React from 'react';
import PropTypes from 'prop-types';
import { CoreLayout } from 'gatsby-theme-thepuzzlers-core';
import { Box } from '@thepuzzlers/pieces';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './fontSize.css';

import { useLocation } from '@reach/router';
// Sections
import { Footer, Navigation } from 'sections';

import 'gatsby-plugin-theme-ui/fonts/fontImports';
import { Banner } from 'components';

gsap.registerPlugin(ScrollTrigger);

const Layout = ({ children, pageContext }) => {
  let lastHeight = 0;
  let lastWidth = 0;

  const { pathname } = useLocation();
  const firstPath = React.useRef(null);
  const [showBanner, setShowBanner] = React.useState(true);

  const setDocHeight = () => {
    if (
      Math.abs(lastWidth - window.visualViewport.width) > 100 ||
      Math.abs(lastHeight - window.visualViewport.height) > 100
    ) {
      lastHeight = window.visualViewport.height;
      lastWidth = window.visualViewport.width;

      document.documentElement.style.setProperty(
        '--vh',
        `${window.visualViewport.height / 100}px`
      );
    }
  };

  React.useEffect(() => {
    setDocHeight();
    window.addEventListener('resize', setDocHeight);
    window.addEventListener('orientationchange', setDocHeight);
  }, []);

  React.useEffect(() => {
    if (firstPath.current === null) {
      firstPath.current = pathname;
    } else if (firstPath.current !== pathname) {
      if (showBanner === true) {
        setShowBanner(false);
      }
    }
  }, [pathname]);

  return (
    // CoreLayout includes PageContextProvider & Global component
    <CoreLayout pageContext={pageContext}>
      {showBanner && <Banner />}
      <Navigation />
      <Box
        as="main"
        sx={{
          position: 'relative',
          bg: 'background',
          overflow: 'hidden'
        }}>
        {children}
      </Box>
      <Footer />
    </CoreLayout>
  );
};

Layout.propTypes = {
  pageContext: PropTypes.object.isRequired
};

export default Layout;
